import { isEmpty } from 'lodash'

export const defaultSelectedItem = (
  allItems = [],
  initialItemUuid = '',
  selectedItemUuid = '',
  modifierUuid = '',
  selectedItems = []
) => {
  const initialItem = allItems.find(
    (item) => item.uuid === initialItemUuid
  )
  const newSelectedItem = allItems.filter(
    (item) => item.uuid === selectedItemUuid
  )

  const initialItemExternalRefIds =
    initialItem?.itemCategoryExternalRefIds.filter(
      (refId) => refId !== modifierUuid
    )

  if (
    !selectedItems.includes(initialItemUuid) &&
    !isEmpty(initialItem)
  ) {
    return [
      {
        ...initialItem,
        itemCategoryExternalRefIds: initialItemExternalRefIds,
        itemCategoryPreferences: {
          [modifierUuid]: {
            ...initialItem?.itemCategoryPreferences[modifierUuid],
            defaultModifier: false,
          },
        },
      },
    ]
  } else if (isEmpty(selectedItemUuid)) {
    return []
  } else if (!isEmpty(selectedItemUuid) && !isEmpty(initialItem)) {
    return [
      {
        ...newSelectedItem[0],
        itemCategoryExternalRefIds: [
          ...newSelectedItem[0]?.itemCategoryExternalRefIds,
          modifierUuid,
        ],
        itemCategoryPreferences: {
          [modifierUuid]: {
            ...newSelectedItem[0]?.itemCategoryPreferences[
              modifierUuid
            ],
            defaultModifier: true,
          },
        },
      },
      {
        ...initialItem,
        itemCategoryExternalRefIds: initialItemExternalRefIds,
        itemCategoryPreferences: {
          [modifierUuid]: {
            ...initialItem?.itemCategoryPreferences[modifierUuid],
            defaultModifier: false,
          },
        },
      },
    ]
  } else {
    return [
      {
        ...newSelectedItem[0],
        itemCategoryExternalRefIds: [
          ...newSelectedItem[0]?.itemCategoryExternalRefIds,
          modifierUuid,
        ],
        itemCategoryPreferences: {
          [modifierUuid]: {
            ...newSelectedItem[0]?.itemCategoryPreferences[
              modifierUuid
            ],
            defaultModifier: true,
          },
        },
      },
    ]
  }
}
